import * as React from "react";
import { forwardRef } from "react";
const UsbPortsIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.627 2.653a.75.75 0 0 1 1.004.052l2.149 2.15.052.057a.75.75 0 0 1-1.056 1.055l-.057-.051-.869-.87v8.378l2.199-2.199v-.942a.75.75 0 0 1-.7-.747v-1.5a.75.75 0 0 1 .75-.75h1.5l.077.004a.75.75 0 0 1 .673.746v1.5l-.004.077a.75.75 0 0 1-.746.673h-.05v1.25a.75.75 0 0 1-.22.53l-3.48 3.48v3.071a2.25 2.25 0 0 1-.75 4.369 2.25 2.25 0 0 1-.75-4.37v-.969L7.67 13.966a.75.75 0 0 1-.22-.53v-1.683c-.42-.266-.7-.733-.7-1.268a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-.8 1.326v1.313l2.4 2.4V5.046l-.87.87a.75.75 0 0 1-1.06-1.06l2.15-2.15.057-.052zm.474 17.332a.75.75 0 1 0 0 1.5.75.75 0 1 0 0-1.5z"
}));
const ForwardRef = forwardRef(UsbPortsIcon);
export default ForwardRef;